// @flow
import React, { Component } from 'react'
import Helmet from 'react-helmet'
import { connect } from 'react-redux'
import { User } from '../../types'
import { updateUser, updatePassword } from '../../actions/user'
import Avatar from '../../components/Avatar'
import SettingsForm from './components/SettingsForm'
import PasswordForm from './components/PasswordForm'

type Props = {
  user: User,
  errors: Object,
  updateUser: Function,
  updatePassword: Function
}

class Settings extends Component {
  props: Props

  handleSettingsSubmit = (data) =>
    this.props.updateUser(this.props.user.id, data)

  handlePasswordSubmit = (data) =>
    this.props.updatePassword(this.props.user.id, data)

  render() {
    return (
      <div>
        <Helmet title="Settings" />
        <div className="row">
          <div className="col-md-2 col-xs-12">
            <Avatar
              size={100}
              email={this.props.user.email}
              style={{ display: 'block', margin: '0 auto 1rem auto' }}
            />
            <a href="https://en.gravatar.com">Edit with Gravatar</a>
          </div>
          <div className="col-md-10 col-xs-12">
            <SettingsForm
              enableReinitialize
              errors={this.props.errors}
              initialValues={this.props.user}
              onSubmit={this.handleSettingsSubmit}
            />
            <PasswordForm onSubmit={this.handlePasswordSubmit} />
          </div>
        </div>
      </div>
    )
  }
}

export default connect(
  (state) => ({
    errors: state.user.errors,
    user: state.session.currentUser
  }),
  {
    updateUser,
    updatePassword
  }
)(Settings)



// WEBPACK FOOTER //
// ./src/views/UserSettings/index.js